module.exports = __webpack_public_path__ + "static/media/activity-log.99f51e14.png";